<template>
  <div class="content_page">
    <Tabbar :title="$t('withdrawAccount.editBankAccount')"></Tabbar>
    <div class="content_area">
      <div class="form_card">
        <Tip :content="$t('withdrawAccount.bindNote')" />
        <div class="content_item" v-for="item in bankItems" :key="item.name">
          <CommonFormItem
            :label="item.show_name"
            :required="item.required"
            :note="item.type === 'PhoneWallet' ? item.tips : ''"
          >
            <CommonInput
              v-if="item.name === 'beneficiaryName'"
              :value="userInfo.firstName"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput
              v-else-if="item.name === 'beneficiaryPaternalName'"
              :value="userInfo.middleName"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput
              v-else-if="item.name === 'beneficiaryLastname'"
              :value="userInfo.lastName"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput
              v-else-if="item.name === 'gender'"
              :value="userInfo.gender === 1 ? $t('common.female') : $t('common.male')"
              theme="white"
              type="text"
              disabled
            />
            <CommonInput v-else-if="item.name === 'email'" :value="userInfo.email" theme="white" type="text" disabled />
            <CommonInput
              v-else-if="item.name === 'birthday'"
              :value="userInfo.birthday"
              theme="white"
              type="text"
              disabled
            />
            <template v-else>
              <CommonInput
                v-if="item.type === 'text'"
                v-model="value[item.name]"
                theme="white"
                type="text"
                :maxLength="item.maxLength"
                :minLength="item.minLength || 0"
                :placeholder="item.placeholder"
              />
              <CommonInput
                v-if="item.type === 'PhoneEpay'"
                v-model="value[item.name]"
                theme="white"
                type="text"
                :maxLength="item.maxLength"
                :placeholder="item.placeholder"
              />
              <CommonInput
                v-if="item.type === 'PhoneWallet'"
                v-model="value[item.name]"
                theme="white"
                type="text"
                :maxLength="item.maxLength"
                :placeholder="item.placeholder"
              >
                <template #prefix>
                  <div class="content_phone_prefix">{{ item.prefix }}</div>
                </template>
              </CommonInput>
              <template v-if="item.type === 'selectList'">
                <SelectBankCode
                  v-if="item.name === 'bankCode'"
                  v-model="value[item.name]"
                  :placeholder="item.placeholder"
                />
                <SelectCountry
                  v-if="item.name === 'documentCountry'"
                  v-model="value[item.name]"
                  :placeholder="item.placeholder"
                />
              </template>
              <template v-if="item.type === 'selectDate'">
                <SelectDate v-model="value[item.name]" :maxlength="item.maxLength" :placeholder="item.placeholder" />
              </template>
              <template v-if="item.type === 'select'">
                <SelectList
                  v-model="value[item.name]"
                  :maxlength="item.maxLength"
                  :placeholder="item.placeholder"
                  :columns="item.selectArr"
                />
              </template>
            </template>
          </CommonFormItem>
        </div>
      </div>
      <CommonBtn class="confirm_btn" :text="$t('common.confirm')" :onClick="EditBankCard" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import SelectDate from '../components/SelectDate'
import SelectList from '../components/SelectList'
import SelectBankCode from '../components/SelectBankCode'
import SelectCountry from '../components/SelectCountry'
import { Toast, DatetimePicker } from 'vant'
import Tabbar from '../components/Tabbar.vue'
import bankData from '../bankdata'
import CommonBtn from '@/components/CommonBtn'
import CommonFormItem from '@/components/CommonFormItem'
import CommonInput from '@/components/CommonInput'
import Tip from '@/components/LinkAccount/Tip.vue'

Vue.use(DatetimePicker)

export default {
  name: 'EditBankAccount',
  data() {
    return {
      bankItems: [],
      value: {},
      userInfo: {},
      paramsAccount: undefined,
      paramsBankType: undefined,
      paramsWithdrawId: undefined,
      bankCode: {},
      countryNo: this.$store.state.userInfo.countryNo,
      withdrawType: undefined
    }
  },
  components: {
    Tabbar,
    SelectDate,
    SelectList,
    SelectBankCode,
    SelectCountry,
    CommonBtn,
    CommonFormItem,
    CommonInput,
    Tip
  },
  created() {
    const countryNo = this.$store.state.userInfo.countryNo
    let bankItems = bankData['countryNo_' + countryNo]
    if (!bankItems) {
      bankItems = bankData['Epay']
    }
    if (bankItems) {
      if (this.$store.state.userInfo.lastName) {
        this.bankItems = bankItems
      } else {
        this.bankItems = bankItems.filter((each) => each.name !== 'beneficiaryLastname')
      }
    } else {
      this.bankItems = []
    }
    this.paramsAccount = this.$route.params.account
    this.paramsBankType = this.$route.params.bankType
    this.paramsWithdrawId = this.$route.params.withdrawId
    this.withdrawType = this.$route.params.withdrawType
    this.userInfo = this.$store.state.userInfo
    if (this.$route.name === 'BindEWalletAccount') {
      this.title = this.$t('withdrawAccount.bindMobileMoneyAccount')
    }
    this.UserBankCardDetail()
    if (!this.$route.params.account) {
      // 不存在待转账的用户，返回上一页
      this.$router.back()
    }
  },
  methods: {
    EditBankCard() {
      const data = { ...this.value }
      if (
        this.countryNo !== 48 &&
        this.countryNo !== 54 &&
        this.countryNo !== 89 &&
        this.countryNo !== 150 &&
        this.countryNo !== 160 &&
        this.countryNo !== 193 &&
        this.value.bankCode
      ) {
        data.bankCode = this.value.bankCode.bankCode
        data.bankName = this.value.bankCode.bankName
      } else {
        data.bankCode = this.value.bankCode
        data.bankName = this.value.bankName
      }
      if (this.countryNo === 175 && !/^SA[0-9A-Z]{22}$/.test(data.bankAccount)) {
        // 沙特阿拉伯的IBAN限制必须以SA开头后接22位数字
        Toast(this.$t('bankData.ibanStyleToast'))
        return
      }
      const notIn = ['beneficiaryName', 'beneficiaryPaternalName', 'beneficiaryLastname', 'gender', 'email', 'birthday']
      const required = this.bankItems
        .filter((each) => each.required || false)
        .filter((each) => notIn.indexOf(each.name) === -1)
      if (required && required.length > 0) {
        for (let i in required) {
          if (!data[required[i].name]) {
            Toast(this.$t('withdrawAccount.fieldEmptyToast', [required[i].show_name]))
            return
          }
        }
      }
      // 检查长度是否符合要求
      const limitMinLength = ['bankAccount', 'bankBranch']
      // 遍历要求最小长度的，检查对应值是否满足条件
      const valueMinLength = this.bankItems
        .filter((each) => each.minLength || false)
        .filter((each) => limitMinLength.indexOf(each.name) !== -1)
      if (valueMinLength && valueMinLength.length > 0) {
        for (let i in valueMinLength) {
          if (data[valueMinLength[i].name].length < valueMinLength[i].minLength) {
            Toast(
              this.$t('withdrawAccount.fieldLengthToast', [valueMinLength[i].show_name, valueMinLength[i].minLength])
            )
            return
          }
        }
      }

      const countryNo = this.$store.state.userInfo.countryNo
      if (countryNo === 198 || countryNo === 209) {
        data.phone = data.phonePrefix + data.phone
        data.bankAccount = data.phone
        data.accountType = 'mobile'
        delete data.phonePrefix
      }
      data.bankType = this.paramsBankType
      data.oldAccount = this.paramsAccount
      data.withdrawId = this.paramsWithdrawId
      this.$http
        .post(window.serverPath + '/api/account/EditUserBankCard', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.$router.replace({
              name: 'bankcardResult',
              params: { eventId: 1 }
            })
          } else if (res.data.code === '60402') {
            Toast(res.data.message)
          } else {
            Toast(this.$t('basicLevel.failToast'))
          }
        })
        .catch((err) => console.log(err))
    },
    UserBankCardDetail() {
      const data = {
        bankAccount: this.paramsAccount,
        userId: this.$store.state.userInfo.userId
      }
      if (this.paramsAccount) {
        this.$http
          .post(window.serverPath + '/api/account/UserBankCardDetail', data)
          .then((res) => {
            if (res.data && res.data.code === '200') {
              // 优化下解决响应式问题
              const data = res.data.data
              Object.keys(data).forEach((key) => {
                Vue.set(this.value, key, data[key])
              })
              if (![48, 54, 89, 150, 160, 193].includes(this.countryNo)) {
                Vue.set(this.value, 'bankCode', {
                  bankCode: data.bankCode,
                  bankName: data.bankName
                })
              }
            } else {
              Toast({ message: this.$t('withdrawAccount.queryFailedToast') })
            }
          })
          .catch((err) => console.log(err))
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
}

.content_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content_area {
  width: 100%;
  padding: 0.16rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.16rem;
}

.form_card {
  width: 100%;
  padding: 0.12rem 0;
  box-sizing: border-box;
  border-radius: 0.18rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.form_card .content_item_tip_box {
  margin: 0;
}

.content_item {
  width: 100%;
}

.confirm_btn {
  width: 100% !important;
  height: 0.48rem !important;
  font-size: 0.16rem !important;
  font-weight: 600 !important;
  line-height: 0.24rem !important;
  border-radius: 0.08rem !important;
  background: #3ebb6f !important;
}

.content_phone_prefix {
  font-size: 0.16rem;
  width: 1rem;
  text-align: right;
}
</style>




// WEBPACK FOOTER //
// src/views/EditBankAccount.vue